import React from "react";
import Typography from "@material-ui/core/Typography";

const Title = (props) => {
  return (
    <Typography variant="h6" gutterBottom style={{ marginRight: "auto" }}>
      {props.children}
    </Typography>
  );
};

export default Title;
